export const OFFERING_STATUS = {
  OPENING: 'Opening',
  CLOSING: 'Closing',
};

export const OFFERING_STATUS_BADGE = {
  Opening: 'success',
  Closing: 'secondary',
};

export const SUBMISSION_STATUS = {
  DRAFT: 'Draft',
  SUBMITTED: 'Submitted',
};

export const SUBMISSION_STATUS_BADGE = {
  Draft: 'warning',
  Submitted: 'primary',
};

export const SEARCHABLE_FIELDS = ['procId', 'title', 'description'];

export const SORTABLE_FIELDS = [
  'procId',
  'title',
  'procurementType',
  'procurementMethod',
  'description',
  'offeringStatus',
  'submissionStatus',
];

export const DEFAULT_PAGE_SIZE = 10;

/** Derived: 'Opening' if submissionDeadline >= now, else 'Closing' */
export const deriveOfferingStatus = (submissionDeadline, now = new Date()) => {
  if (!submissionDeadline) return OFFERING_STATUS.CLOSING;
  return new Date(submissionDeadline) >= now
    ? OFFERING_STATUS.OPENING
    : OFFERING_STATUS.CLOSING;
};

/** true → show View (eye); false → show Edit (pencil) */
export const isViewOnly = (offeringStatus, submissionStatus) =>
  offeringStatus === OFFERING_STATUS.CLOSING ||
  submissionStatus === SUBMISSION_STATUS.SUBMITTED;
